Ext.define('SA.ChartLegend', {
    alias: 'widget.chart-legend',
    extend: 'SA.view.SimpleContainer',

    cls: 'sa-chart-legend',
    isSummaryMode: true,

    initComponent() {
        this.editContent = Ext.widget({...this.content.edit, hidden: true});
        this.summaryContent = Ext.widget({...this.content.summary, hidden: true});

        this.items = [
            {
                xtype: 'chart-legend-header',
                itemId: 'header'
            },
                this.editContent,
                this.summaryContent,
            {
                xtype: 'chart-legend-mode-button',
                itemId: 'modeButton'
            }
        ];

        this.callParent();

        this.header = this.down('#header');
        this.modeButton = this.down('#modeButton');

        this.refreshMode();
    },

    initEvents() {
        this.callParent();

        this.modeButton.on('click', this.toggleMode, this);

        this.getEl().on('mousedown', this.onDragStart, this);
    },

    onDragStart(ev) {
        if (['.sa-button', '.sa-text-field', '.sa-toggle-switch', '.sa-number-field-2', 'a'].some(sel => ev.getTarget(sel))) {
            return;
        }

        var el = this.getEl(),
            offsetRight = el.getX() + el.getWidth() - ev.getX(),
            offsetTop = ev.getY() - el.getY();

        ev.preventDefault();

        this.mon(Ext.getDoc(), 'mousemove', onDragMove, this, {preventDefault: true});
        this.mon(Ext.getDoc(), 'mouseup', onDragStop, this, {single: true});

        this.addCls('sa-chart-legend-dragging');

        function onDragMove(ev) {
            var offsetParent = Ext.get(el.dom.offsetParent),
                right = offsetParent.getX() + offsetParent.getWidth() - ev.getX() - offsetRight,
                top = ev.getY() - offsetParent.getY() - offsetTop;

            el.setStyle({
                right: `${Ext.Number.constrain(right, 0, offsetParent.getWidth() - el.getWidth())}px`,
                top: `${Ext.Number.constrain(top, 0, offsetParent.getHeight() - el.getHeight())}px`
            });
        }

        function onDragStop() {
            this.mun(Ext.getDoc(), 'mousemove', onDragMove, this);

            this.removeCls('sa-chart-legend-dragging');
        }
    },

    onEditContentEvent(event, method, scope) {
        this.editContent.on(event, method, scope);
    },

    refreshMode() {
        this.header.setIsSummaryMode(this.isSummaryMode);
        this.modeButton.setIsSummaryMode(this.isSummaryMode);

        this.editContent.setVisible(!this.isSummaryMode);
        this.summaryContent.setVisible(this.isSummaryMode);
    },

    setState(state) {
        this.editContent.setState(state);
        this.summaryContent.setState(state);
    },

    toggleMode() {
        this.isSummaryMode = !this.isSummaryMode;

        this.refreshMode();
    }
});